import React, { useEffect, useState } from "react";
import { Button, SelectPickerInput } from "@shared/components";
import { changeListeners, FieldErrorMessage, formSubmitHandler, schemaValidators, useAppForm } from "@shared/form";
import { Onboarding, User } from "@shared/models";
import { Option } from "@shared/interfaces";
import { AssignOnboardingToUserDto } from "@containers/User/interfaces/UserForm.interface";

import { getInitValues, validationSchema, prepareSubmitValue } from "./formHelpers";
import "./index.scss";

// The footer buttons sit outside the <form>, so the submit button is tied to it by this id.
const FORM_ID = "assign-onboarding-form";

interface AssignOnboardingFormProps {
  user: User;
  onboardings: Onboarding[];
  onChangeForm: () => void;
  onCloseForm: () => void;
  onSubmitForm: (payload: AssignOnboardingToUserDto) => void;
}

const AssignOnboardingForm: React.FunctionComponent<AssignOnboardingFormProps> = (props) => {
  const { user, onboardings, onChangeForm, onCloseForm, onSubmitForm } = props;
  const [onboardingOptions, setOnboardingOptions] = useState<Option<number>[]>([]);

  useEffect(() => {
    const onboardingOpt = onboardings.map((i) => {
      return {
        label: i.name,
        value: i.id,
      };
    });
    setOnboardingOptions(onboardingOpt);
  }, [onboardings]);

  const form = useAppForm({
    defaultValues: getInitValues(),
    validators: schemaValidators(validationSchema),
    listeners: changeListeners(onChangeForm),
    onSubmit: ({ value }) => {
      onSubmitForm(prepareSubmitValue(value, user));
    },
  });

  return (
    <div className="user-onboarding-form">
      <form id={FORM_ID} onSubmit={formSubmitHandler(form)}>
        <div className="form-content">
          <div className="input-wrapper">
            {/* Wired here, not through `field.Select`, to keep the picker's `name="process"` attribute. */}
            <form.AppField name="onboarding_id">
              {(field) => (
                <>
                  <div className="input">
                    <SelectPickerInput
                      searchable={false}
                      name="process"
                      cleanable={false}
                      data={onboardingOptions}
                      onChange={(value: number) => field.handleChange(value)}
                      labelTitle="Onboarding Flow"
                      value={field.state.value}
                      placeholder="Onboarding"
                    />
                  </div>
                  <FieldErrorMessage />
                </>
              )}
            </form.AppField>
          </div>
        </div>
      </form>

      <div className="form-footer">
        <Button type="button" className="close-btn margin-right" onClick={() => onCloseForm()}>
          Cancel
        </Button>
        <Button type="submit" form={FORM_ID} className="accent padding">
          Assign Onboarding
        </Button>
      </div>
    </div>
  );
};

export default AssignOnboardingForm;
